export enum InvitesExportType {
  tabDelimited = "TXT_TAB",
  commaDelimited = "TXT_COMMA",
  other = "TXT_OTHER",
  xls = "XLS",
  xlsx = "XLSX",
}

export enum InvitesExportOptionKeys {
  showHeaders = "showHeaders",
}